//export const basePath = 'http://192.168.0.104:4000/api';
//export const basePath = 'http://billerelvendedor.xyz/api';
export const basePath = 'http://137.184.18.106:4000/api';
